module.exports = __webpack_public_path__ + "static/media/ITBO07.9c814eaa.jpg";